import axios from 'axios';

interface GeocodeResponse {
  street: string;
  city: string;
  county: string;
  state: string;
  country: string;
  postCode: string;
  streetType: string;
  streetAbbreviation: string;
  neighborhoodAbbreviation: string;
  formattedAddress: string;
  coordinates: {
    lat: number;
    lng: number;
  };
  provider: string;
}

export interface AddressData {
  street: string;
  district: string;
  city: string;
  state: string;
}

class GeocodeService {
  private static instance: GeocodeService;

  private readonly GEO_BASE_URL = '/api/geo';

  private constructor() {}

  public static getInstance(): GeocodeService {
    if (!GeocodeService.instance) {
      GeocodeService.instance = new GeocodeService();
    }
    return GeocodeService.instance;
  }

  public async fetchAddressByCep(cep: string): Promise<AddressData | null> {
    try {
      const cleanCep = cep.replace(/\D/g, '');

      if (cleanCep.length !== 8) {
        return null;
      }

      const formattedCep = `${cleanCep.slice(0, 5)}-${cleanCep.slice(5)}`;

      const response = await axios.get<GeocodeResponse>(
        `${this.GEO_BASE_URL}/v1/geocode?postCode=${encodeURIComponent(formattedCep)}`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );

      return {
        street: response.data.street || '',
        district: response.data.county || '',
        city: response.data.city || '',
        state: response.data.state || '',
      };
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 404) {
          return null;
        }
      }

      console.error('Error fetching address:', error);
      return null;
    }
  }
}

export const geocodeService = GeocodeService.getInstance();

export const fetchAddressByCep = async (cep: string): Promise<AddressData | null> => {
  return geocodeService.fetchAddressByCep(cep);
};

export const isValidCep = (cep: string): boolean => {
  const cleanCep = cep.replace(/\D/g, '');
  return cleanCep.length === 8;
};
